import { render, staticRenderFns } from "./local-errors.vue?vue&type=template&id=30873e66"
import script from "./local-errors.vue?vue&type=script&lang=js"
export * from "./local-errors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports